export const MARKETING_ROUTE_PATHS = [
  "/overview",
  "/features/*",
  "/cases",
  "/resources",
  "/resource/:id/:title",
  "/roi",
  "/suit",
  "/login",
];

export function isMarketingSitePath(pathname) {
  if (!pathname) {
    return false;
  }

  const exact = new Set([
    "/overview",
    "/cases",
    "/resources",
    "/roi",
    "/suit",
    "/login",
  ]);

  if (exact.has(pathname)) {
    return true;
  }

  if (pathname.startsWith("/features")) {
    return true;
  }

  if (pathname.startsWith("/resource/")) {
    return true;
  }

  return false;
}
